import { CircularProgress, Link } from '@mui/material'
import { getSignedOutboundBillOfLading } from 'controllers/outboundTrips/index'
import { useState } from 'react'

interface ViewSignedOutboundBillOfLadingLinkProps {
  disabled?: boolean
  outbobundTripGuid?: string
}

export default function ViewSignedOutboundBillOfLadingLink({ disabled, outbobundTripGuid }: ViewSignedOutboundBillOfLadingLinkProps) {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  return (
    <Link
      onClick={() => {
        if (disabled || isSubmitting || !outbobundTripGuid) return

        setIsSubmitting(true)
        getSignedOutboundBillOfLading(outbobundTripGuid).finally(() => setIsSubmitting(false))
      }}
      sx={{ cursor: disabled ? 'not-allowed' : isSubmitting ? 'wait' : 'pointer' }}
    >
      {isSubmitting ? <CircularProgress size={16} /> : 'View Signed Outbound Bill Of Lading'}
    </Link>
  )
}
